import type { RawComponent } from "../types.js";

/** Classic OfflineAudioContext fingerprint: render a short oscillator through a compressor and hash the output. */
export function collectAudio(): Promise<RawComponent> {
  return new Promise((resolve) => {
    try {
      const AudioContextCtor =
        window.OfflineAudioContext ??
        (window as unknown as { webkitOfflineAudioContext?: typeof OfflineAudioContext })
          .webkitOfflineAudioContext;
      if (!AudioContextCtor) {
        resolve({ name: "audio_hash", rawValue: null });
        return;
      }

      const context = new AudioContextCtor(1, 5000, 44100);
      const oscillator = context.createOscillator();
      oscillator.type = "triangle";
      oscillator.frequency.value = 10000;

      const compressor = context.createDynamicsCompressor();
      compressor.threshold.value = -50;
      compressor.knee.value = 40;
      compressor.ratio.value = 12;
      compressor.attack.value = 0;
      compressor.release.value = 0.25;

      oscillator.connect(compressor);
      compressor.connect(context.destination);
      oscillator.start(0);

      const timeout = setTimeout(() => resolve({ name: "audio_hash", rawValue: null }), 1000);

      context.startRendering();
      context.oncomplete = (event) => {
        clearTimeout(timeout);
        try {
          const channel = event.renderedBuffer.getChannelData(0);
          let sum = 0;
          for (let i = 4500; i < channel.length; i++) {
            sum += Math.abs(channel[i] ?? 0);
          }
          resolve({ name: "audio_hash", rawValue: sum.toString() });
        } catch {
          resolve({ name: "audio_hash", rawValue: null });
        }
      };
    } catch {
      resolve({ name: "audio_hash", rawValue: null });
    }
  });
}
